module.exports = __webpack_public_path__ + "img/numeralia_cedis_3.7fe9e988.svg";